module.exports = __webpack_public_path__ + "static/media/zishoushangjia@2x.a2bf356a.png";